export const isNumber = (value) => {
	const numericPattern = /^\d+$/;
	return numericPattern.test(value);
};

export default isNumber;
